import request from '@/utils/request'
import store from '@/store'

/**
 * 请求手机号列表和开放的国家区域列表
 * @returns
 */
export function getAreaConfigInfo() {
  return request({
    method: 'get',
    url: store.getters.baseUrl + 'vstore-api/user/config/areaConfigInfo'
  })
}

export function getSystemMenu (data) {
  return request({
    method: 'get',
    url: store.getters.baseUrl + 'auth-web/services/resource/userSystemMenu.json',
    data
  })
}
// 获取手机验证码 todo
export function sendLoginSmsCode (params) {
  return request({
    method: 'get',
    url: store.getters.baseUrl + 'vstore-api/user/login/verifyCode',
    params,
    needSign: true
  })
}

// 重置密码验证码（短信，邮箱） todo
export function sendResetPwdCode (params) {
  return request({
    method: 'get',
    url: store.getters.baseUrl + 'vstore-api/user/info/reset/pwd/verifyCode',
    params,
    needSign: true
  })
}

// 重置密码前校验
export function verifyCodeForResetPwd (params) {
  return request({
    method: 'get',
    url: store.getters.baseUrl + 'vstore-api/user/info/reset/pwd/check/verifyCode',
    params
  })
}

// 邮箱注册验证码
export function sendEmailRegisterCode (params) {
  return request({
    method: 'get',
    url: store.getters.baseUrl + 'vstore-api/user/login/email/verifyCode',
    params
  })
}

// 重置密码
export function resetPwd (data) {
  return request({
    method: 'PUT',
    url: store.getters.baseUrl + 'vstore-api/user/info/reset/pwd',
    data
  })
}

// 获取图形验证码
export function crateCaptcha (params) {
  return request({
    method: 'get',
    url: store.getters.baseUrl + 'vstore-api/user/login/captcha',
    params
  })
}
// 登录认证
export function oAuthLogin (data) {
  return request({
    method: 'POST',
    url: store.getters.baseUrl + 'vstore-api/user/oauth/oAuthLogin',
    data: data
  })
}
// 确认授权for oauth2
export function authorize (data) {
  return request({
    method: 'POST',
    url: store.getters.baseUrl + 'vstore-api/user/oauth/authorize.json',
    data: data
  })
}
// 确认授权for h5
export function authorizeUnredirect (data) {
  return request({
    method: 'POST',
    url: store.getters.baseUrl + 'vstore-api/user/oauth/authorize/1',
    data: data
  })
}
